import React from "react";
import { accent } from "../styles/theme";

const Footer = ({ t, goPage }) => (
  <footer style={{ background: t.footerBg, borderTop: `1px solid ${t.footerBorder}`, padding: "32px 24px 24px", marginTop: "60px" }}>
    <div style={{ maxWidth: 780, margin: "0 auto" }}>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "16px", marginBottom: "20px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <div style={{ width: 28, height: 28, background: `linear-gradient(135deg,${accent},#4f46e5)`, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", padding: "4px" }}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none" style={{width:"100%",height:"100%"}}>
              <path d="M 20 12 L 10 32 L 20 52" stroke="#ffffff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M 44 32 L 54 42 L 44 52" stroke="#ffffff" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M 20 36 L 28 44 L 48 18" stroke="#10B981" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <span style={{ fontFamily: "'Bricolage Grotesque',sans-serif", fontSize: "14px", fontWeight: 800, color: t.text }}>My<span style={{ color: accent }}>ATScore</span></span>
        </div>
        <div style={{ display: "flex", gap: "16px", flexWrap: "wrap" }}>
          <button onClick={() => goPage("blog")} className="footer-link">Resources</button>
          <button onClick={() => goPage("about")} className="footer-link">About Us</button>
          <button onClick={() => goPage("contact")} className="footer-link">Contact Us</button>
          <button onClick={() => goPage("faq")} className="footer-link">FAQ</button>
          <button onClick={() => goPage("privacy")} className="footer-link">Privacy Policy</button>
          <button onClick={() => goPage("terms")} className="footer-link">Terms of Service</button>
          <button onClick={() => goPage("refund")} className="footer-link">Refund Policy</button>
          <button onClick={() => goPage("shipping")} className="footer-link">Shipping Policy</button>
        </div>
      </div>

      <div style={{ borderTop: `1px solid ${t.footerBorder}`, paddingTop: "16px", display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "8px", position: "relative" }}>
        <p style={{ fontSize: "12px", color: t.text4 }}>© 2026 MyATScore. All rights reserved.</p>
        <p style={{ fontSize: "12px", color: t.text4 }}>Secure payments · Credits valid for 12 months of activity · No subscription</p>
      </div>
    </div>
  </footer>
);

export default Footer;
